import { prefixObjectValues } from '../utils';

const modal = {
  title: 'title',
  docDesc: 'doc-desc',
  docName: 'doc-name',
  docCategory: 'doc-category',
  docType: 'doc-type',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
  selectedFiles: 'selected-files',
  selectedFileName: 'selected-file-name',
  removeFileBtn: 'remove-file-btn',
  combineFiles: 'combine-files',
  fileRowType: 'file-row-type',
  fileRowCategory: 'file-row-category',
  fileRowError: 'file-row-error',
  fileRowNotice: 'file-row-notice',
  fileTypeFormatError: 'file-type-format-error',
  fileTypeHeader: 'file-type-header',
  fileCategoryHeader: 'file-category-header',
};

export default prefixObjectValues(modal, 'account-documents-form');
